export class Logger {
    logSuccess(message: string) {
        //process.stdout.write(`\x1b[32msuccess\x1b[0m ${message}\n`)
    }

    logInfo(message: string) {
        //process.stdout.write(`\x1b[34minfo\x1b[0m ${message}\n`)
    }

    logError(message: string) {
        //process.stdout.write(`\x1b[31merror\x1b[0m ${message}\n`)
    }

    logWarning(message: string) {
        //process.stdout.write(`\x1b[33mwarning\x1b[0m ${message}\n`)
    }

}

export default new Logger();
